import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import zhCN from './zh-CN'
import jaJP from './ja-JP'
import store from '../store'

Vue.use(VueI18n)

export const defaultLang = 'ja-JP'

export const messages = {
  'zh-CN': {
    '_lang': '简体中文',
    ...zhCN,
    ...zhCNLocale
  },
  'ja-JP': {
    '_lang': '日本語',
    ...jaJP,
    ...jaLocale
  }
}

export const setLang = (lang) => {
  Cookies.set('language', lang)
  store.state.language = lang
}

export default new VueI18n({
  locale: Cookies.get('language') || defaultLang,
  messages
})
